export default __webpack_public_path__ + "static/media/ashutosh_tiwari_core.c5c474d4.jpg";